// src/features/owner/sections/users/VerificationsSection.tsx
import { useOwnerUsers } from '@/hooks';
import { useOwnerAction } from '@/hooks/useOwnerAction';
import { Button } from '@/ui';
import { OwnerPanel, DataTable } from '../../components';
import type { Column } from '../../components';
import type { OwnerUserRow } from '@/core/models';

export function VerificationsSection() {
  const { data, loading, error, refetch } = useOwnerUsers('', '1');
  const action = useOwnerAction();

  const columns: Column<OwnerUserRow>[] = [
    {
      key: 'handle',
      header: 'User',
      sortBy: (r) => r.handle,
      render: (r) => `${r.name} ${r.handle}`,
    },
    {
      key: 'joined',
      header: 'Joined',
      sortBy: (r) => r.joinedAt,
      render: (r) => new Date(r.joinedAt).toLocaleDateString(),
    },
    {
      key: 'actions',
      header: '',
      render: (r) => (
        <Button
          variant="ghost"
          onClick={async () => {
            await action.setVerified(r.id, false);
            refetch();
          }}
        >
          Remove verification
        </Button>
      ),
    },
  ];
  if (loading) return <p style={{ opacity: 0.6 }}>Loading…</p>;
  return (
    <OwnerPanel title="Verified accounts">
      <DataTable<OwnerUserRow>
        columns={columns}
        rows={data ?? []}
        rowKey={(r) => r.id}
        emptyIcon="verify"
        emptyMessage={error ?? 'No verified accounts yet'}
      />
    </OwnerPanel>
  );
}
